import { UserManager, WebStorageStateStore } from "oidc-client";

export const getUserManagerAsync = async () => {
    const oidcConfig = {
        authority: process.env.REACT_APP_AUTHORITY, // Replace <TENANT_ID> with your Azure AD tenant ID
        client_id: process.env.REACT_APP_CLIENT_ID, // Replace <CLIENT_ID> with your Azure AD application (client) ID
        redirect_uri: process.env.REACT_APP_REDIRECT_URI, // Your app's redirect URI (must match Azure AD configuration)
        response_type: "code", // Use Authorization Code Flow
        scope: process.env.REACT_APP_SCOPE, // Define scopes for OpenID Connect and API access
        post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI, // URL to redirect after logout
        userStore: new WebStorageStateStore({ store: window.localStorage }), // Use localStorage for state storage
    };

    
    const userManager = new UserManager(oidcConfig);

    return userManager;
};